/**
 * Photoswipe 5
 */
import PhotoSwipeLightbox from 'photoswipe/lightbox';

// Init with options
// see https://photoswipe.com/documentation/options.html
const galleries = Array.from(document.getElementsByClassName('js-photoswipe'));

for (const gallery of galleries) {

  const lightbox = new PhotoSwipeLightbox({
    gallery,
    children: 'a',
    pswpModule: () => import('photoswipe')
  });
  lightbox.init();
}
